/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext, useState } from "react";
import { graphql } from "gatsby";
import { DocumentContext } from "~context/DocumentContext";
import Footer from "~components/Footer";
import GivePaireCTA from "~components/GivePaireCTA";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import SizeChart from "~components/SizeChart.jsx";
import LogoClip from "~components/svg/LogoClip";
import CollectionGrid from "../components/Products/CollectionGrid";
import ExpandedCollectionGrid from "../components/Products/ExpandedCollectionGrid";
import ProductPageBanner from "../components/ProductPageBanner";

const ProductsPage = ({ data, location }) => {
  const { device } = useContext(DocumentContext);

  const [chart, setChart] = useState(false);

  const getItems = (categories, legacyCategories = []) => {
    const items = [];

    if (categories.length > 0) {
      categories.forEach(category => {
        const productGroup = [];

        if (data?.allSanityProduct?.edges?.[0]) {
          data.allSanityProduct.edges.forEach(({ node }) => {
            if (node.handle.search(`free`) !== -1) {
              return;
            }
            if (
              node.productType.toLowerCase() === category.name.toLowerCase() &&
              node.shopifyProduct?.variants?.[0]
            ) {
              productGroup.push(node);
            }
          });
        }

        productGroup.sort((a, b) => {
          const priorityA = a.priority;
          const priorityB = b.priority;

          if (priorityA < priorityB) {
            return -1;
          }

          if (priorityA > priorityB) {
            return 1;
          }

          return 0;
        });

        items.push({
          title: category.name,
          products: productGroup,
          link: category.link,
          image: category.image || productGroup?.[0]?.image
        });
      });
    } else {
      // TODO legacy field
      legacyCategories.forEach(jumpTarget => {
        const productGroup = [];

        if (data?.allSanityProduct?.edges?.[0]) {
          data.allSanityProduct.edges.forEach(({ node }) => {
            if (node.handle.search(`free`) !== -1) {
              return;
            }
            if (
              node.productType.toLowerCase() === jumpTarget.toLowerCase() &&
              node.shopifyProduct?.variants?.[0]
            ) {
              productGroup.push(node);
            }
          });
        }

        productGroup.sort((a, b) => {
          const priorityA = a.priority;
          const priorityB = b.priority;

          if (priorityA < priorityB) {
            return -1;
          }

          if (priorityA > priorityB) {
            return 1;
          }

          return 0;
        });

        items.push({
          title: jumpTarget,
          products: productGroup,
          image: productGroup?.[0]?.image
        });
      });
    }

    return items;
  };

  const shopItems = getItems(
    data.sanityProductsPage.shopCategories,
    data.sanityProductsPage.jumpTargets
  );
  const shopOtherItems = getItems(data.sanityProductsPage.shopOtherCategories);
  const isBannerEnabled = data.sanityProductPageBanner?.enabled;
  return (
    <>
      <SEO
        customTitle={data.sanityProductsPage.title}
        path={location.pathname}
      />

      <Layout className="products-page w-full relative">
        <SizeChart chart={chart} setChart={setChart} />

        {isBannerEnabled && (
          <div className="pt-20 xs:pt-0 mb-v1">
            <ProductPageBanner></ProductPageBanner>
          </div>
        )}

        {device === `desktop` && (
          <div className="animation-appear-down-slow animation-delay-2 w-full absolute top-0 right-0 flex items-end justify-end">
            <LogoClip className="w-1/2" />
          </div>
        )}

        <section className="relative pb-v6 xs:pb-24">
          {[`categoryCarousel`, `categoryStacked`].includes(
            data.sanityProductsPage.shopDisplayType
          ) ? (
            <CollectionGrid
              data={data}
              title={data.sanityProductsPage.title}
              items={shopItems}
              displayMode={
                data.sanityProductsPage.shopDisplayType === `categoryCarousel`
                  ? `carousel`
                  : `wrap`
              }
              defCategory={location.state?.category}
              className={`${isBannerEnabled || `pt-v12 xs:pt-32`}  mb-v1`}
              setChart={setChart}
            />
          ) : (
            <ExpandedCollectionGrid data={data} setChart={setChart} />
          )}

          {data.sanityProductsPage.shopOtherVisible &&
            shopOtherItems.length > 0 && (
              <CollectionGrid
                data={data}
                title={data.sanityProductsPage.shopOtherTitle}
                items={shopOtherItems}
                displayMode={
                  data.sanityProductsPage.shopOtherDisplayType ===
                  `categoryCarousel`
                    ? `carousel`
                    : `wrap`
                }
                defCategory={location.state?.category}
                setChart={setChart}
              />
            )}
        </section>

        <GivePaireCTA />
      </Layout>

      <Footer />
    </>
  );
};

export default ProductsPage;

export const query = graphql`
  query ProductsPage {
    sanityProductsPage {
      title
      shopDisplayType
      jumpTargets
      shopCategories {
        name
        link
        image {
          asset {
            fluid(maxWidth: 768) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
      shopOtherVisible
      shopOtherTitle
      shopOtherDisplayType
      shopOtherCategories {
        name
        link
        image {
          asset {
            fluid(maxWidth: 768) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
    }

    allSanityProduct {
      edges {
        node {
          title
          handle
          priority
          tagline
          productType
          packSize

          image {
            asset {
              fluid(maxWidth: 768) {
                ...GatsbySanityImageFluid
              }
            }
          }

          availableColours {
            colourRef {
              hexes
              title
            }

            gallery {
              asset {
                fluid(maxWidth: 400) {
                  ...GatsbySanityImageFluid
                }
              }
              altText
            }
          }

          shopifyProduct {
            id
            handle
            title
            description
            images {
              originalSrc
            }
            productType
            vendor
            variants {
              id
              sku
              title
              image {
                originalSrc
              }
              price
              compareAtPrice
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }

    allSanityColourMap {
      edges {
        node {
          hexes
          title
        }
      }
    }

    sanityProductPageBanner {
      content
      enabled
    }
  }
`;
